import { Injectable, inject } from '@angular/core';
import { BackendService, comparator } from '@forgerock/backstage-ui-core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { Library, LibraryId } from './model/library';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
  private backend = inject(BackendService);

  url = '/knowledge-ws/api/v1/library';
  private libraries: Promise<Library[]>;

  getLibraries(): Promise<Library[]> {
    if (!this.libraries) {
      this.libraries = firstValueFrom(
        this.backend
          .get(this.url)
          .pipe(map((libraries: Library[]) => this.filterAndSortLibraries(libraries)))
      );
    }

    return this.libraries;
  }

  async getLibrary(libraryId: LibraryId): Promise<Library> {
    const libraries = await this.getLibraries();
    return libraries.find(library => library.id === libraryId);
  }

  private filterAndSortLibraries(libraries: Library[]): Library[] {
    return libraries
      .filter(library => !library.abandoned)
      .sort(comparator<Library>('displayName', true));
  }

}
